module.exports = __webpack_public_path__ + "static/img/img_cat_my_favorite.9e245ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/img_cat_my_favorite.png
// module id = 542
// module chunks = 1